
import { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import CoursesSection from './components/CoursesSection';
import ClassFeaturesSection from './components/ClassFeaturesSection';
import CurriculumSection from './components/CurriculumSection';
import NaesinSection from './components/NaesinSection';
import ScheduleSection from './components/ScheduleSection';
import CTASection from './components/CTASection';
import LocationSection from './components/LocationSection';
import Footer from './components/Footer';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar isScrolled={isScrolled} />
      <HeroSection />
      <AboutSection />
      <CoursesSection />
      <ClassFeaturesSection />
      <CurriculumSection />
      <NaesinSection />
      <ScheduleSection />
      <CTASection />
      <LocationSection />
      <Footer />
    </div>
  );
}
